import { ref, computed } from 'vue'
import pl from '@/locales/pl.json'
import en from '@/locales/en.json'
import de from '@/locales/de.json'
import cs from '@/locales/cs.json'
import da from '@/locales/da.json'
import et from '@/locales/et.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import hr from '@/locales/hr.json'
import hu from '@/locales/hu.json'
import it from '@/locales/it.json'
import lt from '@/locales/lt.json'
import nl from '@/locales/nl.json'
import ro from '@/locales/ro.json'
import sk from '@/locales/sk.json'
import sl from '@/locales/sl.json'
import bg from '@/locales/bg.json'
import sv from '@/locales/sv.json' // szwedzki
import lv from '@/locales/lv.json' // łotewski
import fi from '@/locales/fi.json' // fiński
import el from '@/locales/el.json' // grecki
import no from '@/locales/no.json' // grecki

export const currentLang = ref(localStorage.getItem('lang') || 'pl')

export function setLang(lang) {
  currentLang.value = lang
  localStorage.setItem('lang', lang)
  window.dispatchEvent(new Event('languageChanged'))
}

export const translations = computed(() => {
  switch (currentLang.value) {
    case 'en': return en
    case 'de': return de
    case 'cs': return cs
    case 'da': return da
    case 'et': return et
    case 'es': return es
    case 'fr': return fr
    case 'hr': return hr
    case 'hu': return hu
    case 'it': return it
    case 'lt': return lt
    case 'nl': return nl
    case 'ro': return ro
    case 'sk': return sk
    case 'sl': return sl
    case 'bg': return bg
    case 'sv': return sv
    case 'lv': return lv
    case 'fi': return fi
    case 'el': return el // grecja 
    case 'no': return no // norwegia 
    default: return pl
  }
})

export function translate(key) {
  const keys = key.split('.')
  let value = translations.value
  for (const k of keys) {
    value = value?.[k]
    if (typeof value === 'undefined') return key
  }
  return value || key
}
